import React, { useContext, useEffect, useState } from 'react';
import { Spin, Transfer } from 'antd';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import system from "../../../config/systematic";
import fetchApi from '../../../utils/api/fetchApi';
import antMessage from '../../../utils/extend/AntdNotification';
import { SocketContext } from '../../../App';

export default function WarehouseToMenu(props: any) {

    /**后端数据wmService */
    const wmService = system.wmService;

    const { data, closeModal } = props;

    // 扩展分类内容菜式
    // const [expandDetailData, setExpandDetailData] = useState<any>();

    // 推广菜式
    const [promoData, setPromoData] = useState<any>();

    // 点心单菜式
    const [dimSumData, setDimSumData] = useState<any>();

    // 门店菜式
    const [menuData, setMenuData] = useState<any>();

    // 仓库菜式
    const [menuWarehouseData, setMenuWarehouseData] = useState<any>([]);

    // 门店菜式
    const [branchStoreMenuWarehouseData, setBranchStoreMenuWarehouseData] = useState<any>([]);

    const [menusData, setMenusData] = useState<any>();

    const [branchStoreMenuWarehouseKeys, setBranchStoreMenuWarehouseKeys] = useState<any>([]);

    const [menuKeys, setMenuKeys] = useState<any>([]);

    const [promoFoodKeys, setPromoFoodKeys] = useState<any>([]);

    const [dimSumKeys, setDimSumKeys] = useState<any>([]);

    // const [expandDetailKeys, setExpandDetailKeys] = useState<any>([]);

    const [loadingData, setLoadingData] = useState<any>(false);

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    let modalTitle;
    let transferTitle: any;
    let transferDataSource: any;
    let transferTarget: any;

    useEffect(() => {

        switch (data.key) {
            case 'menuWarehouseToBranchStore':
                getDataBaseData('menuWarehouse', 'showMenuWarehouse', setBranchStoreMenuWarehouseKeys, setMenuWarehouseData, undefined);
                break;

            case 'branchStoreMenuWarehouseToMenu':
                getDataBaseData('branchStoreMenuWarehouse', 'showBranchStoreMenuWarehouse', setMenuKeys, setBranchStoreMenuWarehouseData, data);
                break;

            case 'menuToPromo':
                getDataBaseData('menu', 'showMenu', setPromoFoodKeys, setMenusData, data);
                break;

            case 'branchStoreMenuWarehouseToDimSum':
                getDataBaseData('branchStoreMenuWarehouse', 'showBranchStoreMenuWarehouse', setDimSumKeys, setBranchStoreMenuWarehouseData, data);
                break;

            // case 'menuWarehouseToExpandDetail':
            //     getDataBaseData('menuWarehouse', 'showMenuWarehouse', setExpandDetailKeys, setMenuWarehouseData, data);
            //     break;
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getDataBaseData = (apiId: any, apiExtend: any, setKeys: any, setData: any, propsData: any) => {
        fetchApi.GET(wmService, {
            apiId,
            apiExtend,
            // branchStoreId: propsData ? propsData.branchStoreId : localStorage.getItem("currentBranchStoreId"),
            branchStoreId: propsData ? propsData.branchStoreId : contextData?.currentBranchStoreId,
            menuHeadId: propsData ? propsData.menuHeadId : '',
            dimSumHistoryId: propsData ? propsData.dimSumHistoryId : '',
            promoCategoryId: propsData ? propsData.promoCategoryId : '',
            expandCategoryId: propsData ? propsData.expandCategoryId : ''
        }).then(res => {
            if (res.success) {
                setData(res.data);
                const newBranchStoreMenuWarehouseKeys: any = [];
                const newFoodWarehouseData: any = [];

                for (let j = 0; j < res.data.length; j++) {
                    const newData = {
                        key: res.data[j].id.toString(),
                        foodName: res.data[j].foodName,
                        brandName: res.data[j].brand ? res.data[j].brand.brandName : null,
                        menuHeadName: res.data[j].menuHead ? res.data[j].menuHead.menuHeadName : null,
                        disabled: (res.data[j].promoCategoryId === data.promoCategoryId || res.data[j].promoCategoryId === null) ? false : true,
                        chosen: res.data[j].isMenu,
                    };
                    if (newData.chosen) {
                        newBranchStoreMenuWarehouseKeys.push(newData.key);
                    }
                    newFoodWarehouseData.push(newData);
                }

                setKeys(newBranchStoreMenuWarehouseKeys);
                setData(newFoodWarehouseData);
            }
        });
    }

    const handleAction = (apiId: any, apiExtend: any, totalData: any, propsData: any) => {

        fetchApi.POST(wmService, {
            apiId,
            apiExtend,
            totalData,
            // branchStoreId: propsData ? propsData.branchStoreId : localStorage.getItem("currentBranchStoreId"),
            branchStoreId: propsData ? propsData.branchStoreId : contextData?.currentBranchStoreId,
            menuHeadId: propsData ? data.menuHeadId : '',
            dimSumHistoryId: propsData ? data.dimSumHistoryId : '',
            promoCategoryId: propsData ? data.promoCategoryId : '',
            expandCategoryId: propsData ? data.expandCategoryId : '',
            apiData: {
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                }
            }
        }).then((res: any) => {
            if (res.data.message) {
                antMessage('error', res.data.message, 'error');
                setLoadingData(false);
                closeModal(true);
            }
            else {
                antMessage('success', '操作成功', 'success');
                setLoadingData(false);
                closeModal(true);
            }
        })
    }

    const handleOk = async (e: any) => {
        setLoadingData(true);
        switch (data.key) {
            case 'menuWarehouseToBranchStore':
                await handleAction('branchStoreMenuWarehouse', 'branchStoreMenuWarehouseAdd', branchStoreMenuWarehouseData, undefined);
                break;

            case 'branchStoreMenuWarehouseToMenu':
                await handleAction('menu', 'menuAdd', menuData, data);
                break;

            case 'menuToPromo':
                await handleAction('promoCategory', 'promoAdd', promoData, data);
                break;

            case 'branchStoreMenuWarehouseToDimSum':
                // console.log(dimSumData);
                await handleAction('dimSumDetail', 'dimSumAdd', dimSumData, data);
                break;

            // case 'menuWarehouseToExpandDetail':
            //     await handleAction('expandDetail', 'expandDetailAdd', expandDetailData, data);
            //     break;
        };
    };

    // /**关闭窗口并刷新数据 */
    // const handleCancel = (status: Boolean) => {
    //     closeModal(false)
    //     if (status === true) {
    //         getData(true);
    //     }
    // }

    const onChange = (newBranchStoreMenuWarehouseKeys: any, direction: any, moveKeys: any) => {
        switch (data.key) {
            case 'menuWarehouseToBranchStore':
                setBranchStoreMenuWarehouseKeys(newBranchStoreMenuWarehouseKeys);
                setBranchStoreMenuWarehouseData(newBranchStoreMenuWarehouseKeys);
                break;

            case 'branchStoreMenuWarehouseToMenu':
                setMenuKeys(newBranchStoreMenuWarehouseKeys);
                setMenuData(newBranchStoreMenuWarehouseKeys);
                break;

            case 'menuToPromo':
                setPromoFoodKeys(newBranchStoreMenuWarehouseKeys);
                setPromoData(newBranchStoreMenuWarehouseKeys);
                break;

            case 'branchStoreMenuWarehouseToDimSum':
                setDimSumKeys(newBranchStoreMenuWarehouseKeys);
                setDimSumData(newBranchStoreMenuWarehouseKeys);
                break;

            // case 'menuWarehouseToExpandDetail':
            //     setExpandDetailKeys(newBranchStoreMenuWarehouseKeys);
            //     setExpandDetailData(newBranchStoreMenuWarehouseKeys);
            //     break;
        };
    };

    switch (data.key) {

        case 'menuWarehouseToBranchStore':
            modalTitle = "从菜品智库添加到门店";
            transferTitle = ['菜品智库', '门店菜式'];
            transferDataSource = menuWarehouseData;
            transferTarget = branchStoreMenuWarehouseKeys;
            break;

        case 'branchStoreMenuWarehouseToMenu':
            modalTitle = data.brandName + " " + data.branchStoreName + "【" + data.menuHeadName + "】—— 添加菜式";
            transferTitle = ['门店菜式', '现有菜式'];
            transferDataSource = branchStoreMenuWarehouseData;
            transferTarget = menuKeys;
            break;

        case 'menuToPromo':
            modalTitle = data.brandName + " " + data.branchStoreName + "【" + data.promoCategoryName + "】—— 添加推广菜式";
            transferTitle = ['菜谱菜式', '推广菜式'];
            transferDataSource = menusData;
            transferTarget = promoFoodKeys;
            break;

        case 'branchStoreMenuWarehouseToDimSum':
            modalTitle = data.brandName + " " + data.branchStoreName + "【" + data.dimSumHistoryName + "】—— 添加菜式";
            transferTitle = ['门店菜式', '点心单菜式'];
            transferDataSource = branchStoreMenuWarehouseData;
            transferTarget = dimSumKeys;
            break;

        // case 'menuWarehouseToExpandDetail':
        //     modalTitle = data.areaName + "【" + data.expandCategoryName + "】—— 添加扩展分类内容";
        //     transferTitle = ['菜品智库', '扩展分类内容'];
        //     transferDataSource = menuWarehouseData;
        //     transferTarget = expandDetailKeys;
        //     break;
    };

    const returnAntd = () => {
        return (
            <Transfer
                dataSource={transferDataSource}
                titles={transferTitle}
                showSearch
                listStyle={{ width: 400 }}
                targetKeys={transferTarget}
                onChange={onChange}
                render={item => `${item.foodName + (item.menuHeadName ? "（" + item.menuHeadName + "）" : "") + (item.brandName ? "（" + item.brandName + "）" : "")}`}
                // render={item => `${item.foodName + (item.specs > 0 ? "" : " ----【没有设置规格】")}`}
                pagination
            />
        )
    }

    return (
        <>
            <AntDraggableModal
                title={modalTitle}
                open={true}
                okText='确定'
                cancelText='取消'
                cancelButtonProps={{ disabled: loadingData }}
                okButtonProps={{ disabled: loadingData }}
                onOk={handleOk}
                onCancel={() => closeModal(false)}
                closable={false}
                maskClosable={false}
                width={700}
            >
                {loadingData ? (
                    <Spin size="large" tip="Loading...">
                        {returnAntd()}
                    </Spin>
                ) : returnAntd()}
            </AntDraggableModal>
        </>
    );
};